import React from 'react';


import Animation from "../animation/animation";
import Card from "../card/card";
import ContactFormEn from "../contact-form/contact-form-en";
import Grid from "../grid/grid";
import GridLine from "../grid-line/grid-line";
import ProjectSliderEn from "../project-slider/project-slider-en";

import './services.scss';

import automationVideo from '../../f/videos/automation.mp4';
import automationCover from '../../f/img/automation.jpg';
import brandingVideo from '../../f/videos/branding.mp4';
import brandingCover from '../../f/img/branding.jpg';
import grafVideo from '../../f/videos/graf.mp4';
import grafCover from '../../f/img/graf.jpg';
import interfaceVideo from '../../f/videos/interface.mp4';
import interfaceCover from '../../f/img/interface.jpg';
import interiorVideo from '../../f/videos/interior.mp4';
import interiorCover from '../../f/img/interior.jpg';
import navigationVideo from '../../f/videos/navigation.mp4';
import navigationCover from '../../f/img/navigation.jpg';
import prVideo from '../../f/videos/pr.mp4';
import prCover from '../../f/img/pr.jpg';
import promVideo from '../../f/videos/prom.mp4';
import promCover from '../../f/img/prom.jpg';
import smmVideo from '../../f/videos/smm.mp4';
import smmCover from '../../f/img/smm.jpg';
import strategiesVideo from '../../f/videos/strategies.mp4';
import strategiesCover from '../../f/img/strategies.jpg';
import urbanVideo from '../../f/videos/urban.mp4';
import urbanCover from '../../f/img/urban.jpg';
import webVideo from '../../f/videos/web.mp4';
import webCover from '../../f/img/web.jpg';
import inclusiveVideo from '../../f/videos/inclusive.mp4';
import inclusiveCover from '../../f/img/inclusive.jpg';



const ServicesEn = () => {
  return (
      <React.Fragment>
        <div className="services category-list">
          <div className="services-header">
            <h1 className="services-header__text">Competencies <br/> Art. Lebedev Studio</h1>

            <Animation header="advertising, architecture, books, brand identity, fonts, graphic design, industrial design, illustration, interfaces, interior design, logos, mobile apps, motion design, patterns, presentations, urban environment, video, wayfinding, web"/>
            <div className="als-text-container">
              {/* <h1 className="services-container__header">Competencies <br/> Art. Lebedev Studio</h1> */}
              <p className="services__text">
                We&nbsp;love finding the perfect solution to&nbsp;challenging problems for businesses big and small. We&rsquo;re all about making people&rsquo;s lives better through design.
              </p>
            </div>
          </div>
          <div className="services-main">
            <Grid>
              <GridLine>
                <Card
                    url="https://www.artlebedev.com/automation/"
                    type="video"
                    previewContent={automationVideo}
                    poster={automationCover}
                    title="Design automation and Artificial intelligence"
                    description="Collaborations with Nikolai Ironov and high-speed layout. Large-scale design systems, banner generators, template engines for brand books and social media."
                />
                {/*<Card*/}
                {/*    url="https://www.artlebedev.com/strategies/"*/}
                {/*    type="video"*/}
                {/*    previewContent={strategiesVideo}*/}
                {/*    poster={strategiesCover}*/}
                {/*    title="Analytics and Strategies"*/}
                {/*    description="Effective communication, service, market, brand and design strategies, smart web analytics and market research."*/}
                {/*/>*/}
                <Card
                    url="/competencies/branding"
                    type="video"
                    previewContent={brandingVideo}
                    poster={brandingCover}
                    title="Branding"
                    description="Identity, naming, brand books, brand platforms and logos."
                />
                <Card
                    url="/competencies/urban"
                    type="video"
                    previewContent={urbanVideo}
                    poster={urbanCover}
                    title="Urban design and Urbanism"
                    description="Architecture and landscape design, art objects, place branding, and design codes for cities. Facade decoration, urban furniture and objects."
                />
                <Card
                    url="/competencies/graphic"
                    type="video"
                    previewContent={grafVideo}
                    poster={grafCover}
                    title="Graphic design and Creativity"
                    description="Packaging design and construction for any goods, illustrations, patterns, posters, fonts and 3D animation."
                />
                <Card
                    url="/competencies/inclusive"
                    type="video"
                    previewContent={inclusiveVideo}
                    poster={inclusiveCover}
                    title="Inclusive design"
                    description="Adapting sites for people with visual and hearing disabilities, creating a&nbsp;friendly
                    environment, designing specialist devices, designing for engagement."
                />
                <Card
                    url="/competencies/interior"
                    type="video"
                    previewContent={interiorVideo}
                    poster={interiorCover}
                    title="Interiors and Exteriors"
                    description="Design for office interiors, shops, exhibition stands, shop windows and signage. Exteriors for large-scale production facilities and design for attractive urban facades."
                />
                <Card
                    url="/competencies/wayfinding"
                    type="video"
                    previewContent={navigationVideo}
                    poster={navigationCover}
                    title="Wayfinding design"
                    description="Wayfinding systems, signs and pointers, maps and diagrams for transport, parks, shopping centers, offices, warehouses and medical institutions."
                />
                <Card
                    url="/competencies/pr"
                    type="video"
                    previewContent={prVideo}
                    poster={prCover}
                    title="Promotion and PR"
                    description="Media and creative strategies, advertising integrations with bloggers, targeted advertising in digital and social media, PR support."
                />
                <Card
                    url="/competencies/industrial"
                    type="video"
                    previewContent={promVideo}
                    poster={promCover}
                    title="Industrial design"
                    description="Industrial and product design for all kinds of goods, furniture, accessories, equipment, electronic devices, transport, city and street objects."
                />
                <Card
                    url="/competencies/interface"
                    type="video"
                    previewContent={interfaceVideo}
                    poster={interfaceCover}
                    title="Applications and Interfaces"
                    description="Mobile applications, interfaces for information systems, ATMs and terminals, AR and VR applications, UI/UX design."
                />
                <Card
                    url="/competencies/web"
                    type="video"
                    previewContent={webVideo}
                    poster={webCover}
                    title="Sites"
                    description="Promo sites and landing pages, interactive, corporate and promotional sites, intranets and online stores."
                />
                {/*<Card*/}
                {/*    url="/competencies/smm"*/}
                {/*    type="video"*/}
                {/*    previewContent={smmVideo}*/}
                {/*    poster={smmCover}*/}
                {/*    title="СММ и контент"*/}
                {/*    description="Стратегии ведения аккаунтов и&nbsp;автоматизация шаблонов, подборка авторов и&nbsp;копирайтинг, визуальный контент и&nbsp;оформление страниц в&nbsp;соцмедиа."*/}
                {/*/>*/}
              </GridLine>
            </Grid>
          </div>
          <ProjectSliderEn />
          {/*<Animation type="words" />*/}
          <ContactFormEn formId="other"/>
        </div>
      </React.Fragment>
  );
}

export default ServicesEn;
